const baseUrl="https://focusdot.trackingacademy.in/backend/public/api";
// const baseUrl="http://127.0.0.1:8001/api";


export default baseUrl;